import React from 'react'
import { Button, makeStyles } from '@material-ui/core';
import { red, orange, green } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    root: {
        //minWidth: 0,
        //margin: theme.spacing(0.5)
    },
    secondary: {
        backgroundColor: theme.palette.secondary.light,
        '& .MuiButton-label': {
            color: theme.palette.secondary.main,
        }
    },
    primary: {
        backgroundColor: theme.palette.primary.light,
        '& .MuiButton-label': {
            color: theme.palette.primary.main,
        }
    },
    success: {
        //color: theme.palette.getContrastText(green[500]),
        color: '#fff',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    danger: {
        //color: theme.palette.getContrastText(green[500]),
        color: '#fff',
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[700],
        },
    }, warning: {
        //color: theme.palette.getContrastText(green[500]),
        color: '#fff',
        backgroundColor: orange[500],
        '&:hover': {
            backgroundColor: orange[700],
        },
    },
}))

export default function ActionButton(props) {

    const { text, size, color, variant, onClick, ...other } = props;
    const classes = useStyles();

    return (
        <Button
            variant={variant || "contained"}
            size={size || "medium"}
            color={color || "primary"}
            onClick={onClick}
            className={`${classes.root} ${classes[color]}`}
            {...other}>
            {text}
        </Button>
    )
}
